export default class Text {
    constructor(idioma) {
        this.idioma = idioma || 'br'
    }

    getTextoHeader() {
        switch (this.idioma) {
            case 'br':
                return `Trazemos soluções em telecomunicações, telefonia e interfonia para empresas, condomínios e até mesmo residências`
            case 'us':
                return `We bring solutions in telecommunications, telephony and interphony to business, condominiums and even houses`
            default:
                return `Undefined Language`
        }
    }

    getTextoPortifolio() {
        switch (this.idioma) {
            case 'br':
                return [
                    { 
                        imagem: require(`../../images/portifolio/fiscalizavr.jpg`),
                        texto: `De forma rápida e completamente gratuita, o novo aplicativo Fiscaliza VR possibilita você a criar ocorrências, com o objetivo de melhorias e aperfeiçoamento dos serviços prestados pela prefeitura aos cidadãos do município`
                    },
                    {
                        imagem: require(`../../images/portifolio/queimados.jpg`),
                        texto: `Desenvolvimento do Portal da Prefeitura de Queimados, em conjunto com o novo Portal da Transparência da prefeitura, com o objetivo de facilitar o acesso à informação para o cidadão`},
                    {
                        imagem: require(`../../images/portifolio/fiscaliza.jpg`),
                        texto: `O Fiscaliza Já permite cidadãos de diversas cidades evidenciarem os problemas para suas prefeituras, agilizando as soluções desses problemas e melhorando drasticamente a comunicação com seu governo`},
                    {
                        imagem: require(`../../images/portifolio/japeri.jpg`),
                        texto: `Desenvolvimento do Portal da Câmara de Japeri, com informações de transparência e transmissão online gratuita de todas as sessões para os cidadãos`
                    },
                ]
            case 'us':
                return [
                    {
                        imagem: require(`../../images/portifolio/stutrack.jpg`),
                            texto: `Stutrack is a monitoring system via beacons. It is a modern wireless technology capable of keeping track of people's and objects' location, temperature and other resources throw small devices.`
                    },
                    {
                        imagem: require(`../../images/portifolio/florida.jpg`),
                        texto: `"Florida a Gosto" is an app developed for a gastronomic event wich took place on Florida, where were gathered all main restaurants from the region. The app collected all restaurant descriptions, menus and a voting system to elect the best dish.`
                    }
                ]
            default:
                return `Undefined Language`
        }
    }

    getTextoClients() {
        switch (this.idioma) {
            case 'br':
                return [`DESENVOLVIMENTO`, `INFRAESTRUTURA DE T.I.`]

            case 'us': 
            return [`DEVELOPMENT`, `I.T. INFRASTUCTURE`]
            default:
                return `Undefined Language`
        }
    }

    getTextoRodape() {
        switch (this.idioma) {
            case 'br':
                return `As diretrizes e politicas de privacidade de informações de nossos clientes são entendidas como prioridade por toda equipe da City Connect. Desta forma não cedemos informações referentes a nossos clientes a terceiros.`
            case 'us':
                return `
                Our customers' information privacy policies and guidelines are understood as a priority by the entire City Connect team. In this way we do not give information about our customers to third parties.`
            default:
                return `Undefined Language`    
        }
    }

    getDireitosReservados() {
        switch (this.idioma) {
            case 'br':
                return `Todos os direitos reservados - @ City Connect`
            case 'us':
                return `All rights reserved - @ City Connect`
            default:
                    console.log('Idioma não referenciado')
        }
    }

    getTextoKnowMore() {
        switch (this.idioma) {
            case 'br':
                return [
                    `QUER SABER MAIS?`,
                    `VAMOS CONVERSAR`
                ]
            case 'us':
                return [
                    `WANT TO KNOW MORE?`,
                    `LET'S TALK`
                ]
            default:
                    console.log('Idioma não referenciado')
        }
    }

    getOsSystem() {
        switch (this.idioma) {
            case 'br': 
                return `Sistema de OS`
            case 'us':
                return `OS System`
            default: 
                return `Undefined Language`
        }        
    }

    getPassword() {
        
        switch (this.idioma) {
            case 'br':
                return `senha`
            case 'us':
                return `password`
            default:
                return `Undefined Language`
        }
    }

    getUsername() {
        switch (this.idioma) {
            case 'br':
                return `nome de usuário`
            case 'us':
                return `username`
            default:
                return `Undefined Language`
        }
    }

    getLogin() {
        switch (this.idioma) {
            case 'br':
                return `Entrar`
            case 'us':
                return `Sign in`
            default:
                return `Undefined Language`
        }
    }

    getClientesDev() {
        switch (this.idioma) {
            case 'br':
                return [
                    {
                        image: require("../../images/portifolio/fiscaliza.jpg"),
                        cliente: "Fiscaliza Já",
                        projeto: "Aplicativo de Ouvidoria"
                    },
                    {
                        image: require("../../images/portifolio/fiscalizavr.jpg"),
                        cliente: "Fiscaliza VR",
                        projeto: "Prefeitura de Volta Redonda"
                    },
                    {
                        image: require("../../images/portifolio/queimados.jpg"),
                        cliente: "Portal da Prefeitura",
                        projeto: "Prefeitura de Queimados"
                    },
                    {
                        image: require("../../images/portifolio/japeri.jpg"),
                        cliente: "Portal da Câmara",
                        projeto: "Câmara Municipal de Japeri"
                    },
                    {
                        image: require("../../images/portifolio/orlandia.jpg"),
                        cliente: "Aplicativo de Ouvidoria",
                        projeto: "Prefeitura de Orlândia"
                    },
                    {
                        image: require("../../images/portifolio/sao-manuel.jpg"),
                        cliente: "Sistema de Ouvidoria",
                        projeto: "Prefeitura de São Manuel"
                    },
                ]

            case 'us':
                return [
                    {
                        image: require("../../images/portifolio/creation_village.png"),
                        cliente: "Creation Village",
                        projeto: "Stutrack"
                    },
                    {
                        image: require("../../images/portifolio/florida_a_gosto.png"),
                        cliente: "FBF",
                        projeto: "Florida a Gosto"
                    },
                ]
            default:
                return `Undefined Language`
        }
    }

    getClientesInfra() {
        switch (this.idioma) {
            case 'br':
                return [
                    {
                        image: require("../../images/portifolio/jardinopolis.jpg"),
                        cliente: "Serviços de Infraestrutura de T.I.",
                        projeto: "Prefeitura de Jardinópolis"
                    },
                    {
                        image: require("../../images/portifolio/observatorio.jpg"),
                        cliente: "Serviços de Infraestrutura de T.I.",
                        projeto: "Observatório Nacional"
                    },
                    {
                        image: require("../../images/portifolio/rural.jpg"),
                        cliente: "Serviços de Infraestrutura de T.I.",
                        projeto: "UFRRJ"
                    },
                    {
                        image: require("../../images/portifolio/vivo.jpg"),
                        cliente: "Serviços de Infraestrutura de T.I.",
                        projeto: "Vivo - Cronológica"
                    }
                ]

            case 'us':
                return [
                    {
                        image: require("../../images/portifolio/scs.png"),
                        cliente: "I.T. Infrastructure Services",
                        projeto: "SCS Technologies"
                    },
                ]
            default:
                return `Undefined Language`
        }
    }
}